.root {
  align-items: center;
  background: var(--color-surface);
  border: 1.5px dashed var(--color-border-strong);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  padding: 24px;
}

.icon {
  color: var(--color-muted);
}
